import { render, staticRenderFns } from "./ImportPage.vue?vue&type=template&id=2f17f876&"
import script from "./ImportPage.vue?vue&type=script&lang=js&"
export * from "./ImportPage.vue?vue&type=script&lang=js&"
import style0 from "./ImportPage.vue?vue&type=style&index=0&id=2f17f876&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f17f876')) {
      api.createRecord('2f17f876', component.options)
    } else {
      api.reload('2f17f876', component.options)
    }
    module.hot.accept("./ImportPage.vue?vue&type=template&id=2f17f876&", function () {
      api.rerender('2f17f876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/ImportPage.vue"
export default component.exports